import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, openUrl, remove, scrollInfo } from 'kapix-components-vue3'
import formationsCommunicationDigitaleStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'formationsCommunicationDigitale'
const customImplement: CustomStoreImplementationOptions = formationsCommunicationDigitaleStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function formationsCommunicationDigitaleFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('prog-07-communication-digitale.title', 'Formation communication digitale sur-mesure'),
        $description: $translate('prog-07-communication-digitale.description', 'Gratuite et sur-mesure, une formation en communication digitale proposée par l\'un de nos experts Matchers vous permettra de mettre en place une stratégie adaptée à VOS objectifs !'),
        $publishedTime: new Date('2023-03-26T17:16:54.566Z'),
        $modifiedTime: new Date('2023-09-06T12:35:18.060Z'),
        // Constants,
        $constants: {
          blocPreviewProfilExpertTags: [
            { Nom: 'Acquisition' },
            { Nom: 'E-commerce' },
            { Nom: 'SEO' },
            { Nom: 'E-mailing' },
            { Nom: 'Communication 360°' },
            { Nom: 'Fidélisation' },
            { Nom: 'Social media/Ads' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          element1Tags: [
            { Nom: 'Social media / Ads' },
            { Nom: 'Vidéo' },
            { Nom: 'TikTok' },
            { Nom: 'Stratégie de contenu' },
            { Nom: 'Instagram' },
            { Nom: 'Snapchat' },
            { Nom: 'YouTube' },
            { Nom: 'Pinterest' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          element2Tags: [
            { Nom: 'Copywriting' },
            { Nom: 'Storytelling' },
            { Nom: 'Animation site Internet' },
            { Nom: 'SEO/SEA' },
            { Nom: 'Community management' },
            { Nom: 'Acquisition de trafic' },
            { Nom: 'Lead generation' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          element3Tags: [
            { Nom: 'Communication visuelle' },
            { Nom: 'Design' },
            { Nom: 'Charte graphique' },
            { Nom: 'Illustrator' },
            { Nom: 'Design digital' },
            { Nom: 'Infographie' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          dropDownFormationArguments: [
            { Text: '<ul><li>Déterminer sa cible et son positionnement pour l’atteindre.</li></ul>' },
            { Text: '<ul><li>Définir sa promesse, ses points de différentiation (particularité/ADN), objections, produits et verbatims.</li></ul>' },
            { Text: '<ul><li>Cartographier et comparer les acteurs du marché : positionnement, présence, stratégie.</li></ul>' },
            { Text: '<ul><li>Identifier les acteurs inspirationnels pour développer des best practices : positionnement et key success factors</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element4Arguments: [
            { Text: '<ul><li>Identifier son écosystème digital et les liens entre eux : site, réseaux sociaux, newsletters…&nbsp;</li></ul>' },
            { Text: '<ul><li>Connaître les forces du référencement naturel et payant.</li></ul>' },
            { Text: '<ul><li>Sonder les réseaux communautaires et réseaux d’influence.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element5Arguments: [
            { Text: '<ul><li>Mesurer l’importance du Brand Content : quoi, comment et pour générer quoi ?</li></ul>' },
            { Text: '<ul><li>Définir l’identité visuelle de son Brand Content.</li></ul>' },
            { Text: '<ul><li>Maîtriser les fondamentaux du storytelling sur les réseaux sociaux.</li></ul>' },
            { Text: '<ul><li>Savoir comment parler des valeurs de son entreprise, de ses produits et de ses services autour d’un sujet commun thématisé.</li></ul>' },
            { Text: '<ul><li>Évaluer quel canal et quel format choisir en fonction d’un objectif, d’un sujet et d’une cible.</li></ul>' },
            { Text: '<ul><li>&nbsp;Élaborer un planning éditorial.</li></ul>' },
            { Text: '<ul><li>Diffuser ses contenus au-delà de sa sphère communautaire (hashtags, viralisation, paid media, communication d’influence).</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element6Arguments: [
            { Text: '<ul><li>Identifier ls KPI’s à suivre.</li></ul>' },
            { Text: '<ul><li>Mettre en place un dashboard.</li></ul>' },
            { Text: '<ul><li>Mesurer ses actions et en déduire des axes d\'amélioration.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>
        },
        // Data,
        $info: { prog07CommunicationDigitale: scrollInfo() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      blocPreviewProfilExpertClick () {
        openUrl('https://www.matchers.fr/expert/306', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      element1Click () {
        openUrl('https://www.matchers.fr/expert/266', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      element2Click () {
        openUrl('https://www.matchers.fr/expert/457', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      element3Click () {
        openUrl('https://www.matchers.fr/expert/274', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      voirClick () {
        openUrl('https://www.matchers.fr/experts', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return formationsCommunicationDigitaleFactory(storeId)()
}

export const formationsCommunicationDigitaleRaw = formationsCommunicationDigitaleFactory()
export const formationsCommunicationDigitale = () => formationsCommunicationDigitaleRaw() as MergeCustomStore<typeof formationsCommunicationDigitaleStoreCustom.instance>
